/**
 * Input — bordered, terminal-style. Used inside `<FormField>` for label
 * + error wrapping.
 */
import { forwardRef, type InputHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'block w-full h-9 px-3 text-sm rounded',
        'bg-elevated text-text placeholder:text-textFaint',
        'border border-line hover:border-lineHi',
        'focus:outline-none focus:border-fire focus:ring-0',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        invalid && 'border-rose focus:border-rose',
        className,
      )}
      {...rest}
    />
  )
})
